/**
 * 进度上下文解析（CJS，供 Node 单测与 Vue 共用）
 */
function resolveProgressContextFromState(state, globalPageIndex, routeVolNum) {
  const routeVol = routeVolNum ?? Number(state.routeVolNum ?? state.volNum ?? 0)
  const comicId = state.comicId

  const sumLoadedVolumeImages = () =>
    (state.loadedVolumes || []).reduce(
      (sum, vol) => sum + (vol.images?.length ?? 0),
      0,
    )

  for (let i = (state.loadedVolumes || []).length - 1; i >= 0; i--) {
    const vol = state.loadedVolumes[i]
    const start = vol.startIndex
    const imageCount = vol.images?.length ?? ((vol.endIndex ?? start) - start + 1)
    const end = vol.endIndex ?? (start + imageCount - 1)
    if (globalPageIndex >= start && globalPageIndex <= end) {
      return {
        volNum: vol.volNum,
        pageIndex: globalPageIndex - start,
        totalImages: imageCount,
        progressKey: `reading_progress_${comicId}_${vol.volNum}`,
      }
    }
  }

  if (state.nextVolumeNum && state.nextVolumePages?.length > 0) {
    const loadedInNextBuffer = sumLoadedVolumeImages()
    const activeNextCount = state.nextVolumePages.length - loadedInNextBuffer
    if (activeNextCount > 0) {
      const nextStart = state.pages.length + loadedInNextBuffer
      const nextEnd = nextStart + activeNextCount - 1
      if (globalPageIndex >= nextStart && globalPageIndex <= nextEnd) {
        return {
          volNum: state.nextVolumeNum,
          pageIndex: globalPageIndex - nextStart,
          totalImages: activeNextCount,
          progressKey: `reading_progress_${comicId}_${state.nextVolumeNum}`,
        }
      }
    }
  }

  if (globalPageIndex >= 0 && globalPageIndex < state.pages.length) {
    return {
      volNum: routeVol,
      pageIndex: globalPageIndex,
      totalImages: state.totalCount > 0 ? state.totalCount : state.pages.length,
      progressKey: `reading_progress_${comicId}_${routeVol}`,
    }
  }

  return {
    volNum: routeVol,
    pageIndex: globalPageIndex,
    totalImages: state.totalCount > 0 ? state.totalCount : state.pages.length,
    progressKey: `reading_progress_${comicId}_${routeVol}`,
  }
}

module.exports = { resolveProgressContextFromState }
